<template>
  <section>
    <v-dialog
      v-model="isShow"
      width="400px">
      <div class="dialog-header">
        <p>Avatar</p>
        <font-awesome-icon
          icon="times"
          class="close"
          @click="handleCancel"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <div class="cut">
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :fixedBox="option.fixedBox"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :height="option.height"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            :enlarge="option.enlarge"
            :mode="option.mode">
          </vue-cropper>
        </div>
      </div>
      <div class="dialog-footer">
        <v-button
          type="success"
          @click="getCropBlob">Comfirm</v-button>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import { VueCropper }  from 'vue-cropper'
import { uploadOrderFile } from '@/api/order' 
export default {
  name: '',
  components:{
    VueCropper
  },
  props:{
    imgSrc: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 150
    },
    height: {
      type: Number,
      default: 150
    },
    direct:{
      type: Number,
      default: 1
    },
    otherData: {
      type: Object,
      default: () => ({}),
    },
    uploadData: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isShow: false,
      option:{
        img: '',    //裁剪图片的地址
        outputSize: 1,    //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png',   //裁剪生成图片的格式（jpeg || png || webp）
        info: false,    //裁剪框大小信息
        canScale: true,   //图片是否允许滚轮缩放
        autoCrop: true,   //是否默认生成截图框
        autoCropWidth: this.width,    //默认生成截图框宽度
        autoCropHeight: this.height,    //默认生成截图框高度
        fixed: true,    //是否开启截图框宽高固定比例
        full: false,    //false按原比例裁切图片，不失真
        fixedBox: true,   //固定截图框大小，不允许改变
        canMove: true,   //上传图片是否可以移动
        canMoveBox: true,   //截图框能否拖动
        original: false,    //上传图片按照原始比例渲染
        centerBox: true,   //截图框是否被限制在图片里面
        height: true,   //是否按照设备的dpr 输出等比例图片
        infoTrue: false,    //true为展示真实输出图片宽高，false展示看到的截图框宽高
        mode: 'cover'   //图片默认渲染方式
      }
    }
  },
  watch:{
    imgSrc: {
      immediate: true,
      handler(val){
        this.option.img = val
      }
    }
  },
  methods: {
    changeDialog(){
      this.isShow = !this.isShow
    },
    handleCancel(){
      this.isShow = false
    },
    getCropBlob(){
      this.$refs.cropper.getCropBlob(data => {
        let params = new FormData()
        params.append('file', data, 'avatar.png')
        params.append('direct', this.direct)
        Object.keys(this.uploadData).forEach((key) => {
          params.append(key, this.uploadData[key])
        })
        let result = {
          url: URL.createObjectURL(data),
        }
        this.network().uploadOrderFile(params, result)
      })
    },
    network(){
      return{
        uploadOrderFile: async (params, result) => {
          const { data } = await uploadOrderFile(params)
          const { url } = result
          const dataResult = {
            ...data,
            path: data.name,
            thumb_url: url
          }
          this.$emit('uploadSuccess', {
            data: dataResult,
            result,
            otherData: this.otherData,
          })
          this.changeDialog()
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  border-radius: 6px;
  .dialog-header{
    display: flex;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .dialog-body{
    padding: 10px 20px;
    .cut{
      width: 300px;
      height: 300px;
      margin: auto;
      .cropper-view-box{
        border-radius: 100%;
      }
      .cropper-face.cropper-move{
        border-radius: 100%;
      }
    }
  }
  .dialog-footer{
    padding: 10px;
    text-align: center;
  }
}
</style>
